module.exports = __webpack_public_path__ + "img/20200507_135539.3e403c04.jpg";